// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".laprairie-white-caviar{position:relative;width:100%;height:100%;overflow:hidden;box-sizing:border-box}.laprairie-white-caviar #canvas-webgl{position:absolute;top:0;left:0}.laprairie-white-caviar #canvas-webgl.clickable{cursor:pointer}", ""]);
// Exports
module.exports = exports;
